<!-- <h1 mat-dialog-title>Update label</h1> -->
<div mat-dialog-content>
    <p>Please enter value for <b>{{local_data}}</b></p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()"  mat-raised-button color="warn">Ok</button>
  </div>
